// routes
import { PATH_PAGE } from '../../../routes/paths';
// components

// components
import Iconify from '../../../shared/components/Iconify';

// ----------------------------------------------------------------------

const ICON_SIZE = {
    width: 22,
    height: 22,
};

const menuConfig = [
    {
        id: 1,
        title: 'Home',
        icon: <Iconify icon={'eva:home-fill'} {...ICON_SIZE} />,
        path: '/',
    },
    {
        id: 2,
        title: 'Register as a Merchant',
        icon: <Iconify icon={'eva:file-fill'} {...ICON_SIZE} />,
        path: '/auth/register',
    },
];

export default menuConfig;
